import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, Container, Col, Row, UncontrolledTooltip } from 'reactstrap'
import { InputContainer, TextEditor } from 'components/ideal-core-ui'
import Select from 'react-select'
import cn from 'classnames'
import { FaRegFilePdf, FaInfoCircle } from 'react-icons/fa'
import { EmailFiles } from 'components/common/EmailFiles'
import s from './EmailProposalModal.scss'
import CreatableSelect from 'react-select/creatable'
import { EMAIL_SPLIT_MODE } from 'utils/constants'

const EmailProposalModal = ({
  proposal,
  mainContacts,
  allCCContacts,
  toContacts,
  ccContacts,
  subject,
  emailBody,
  toggleEmailProposalModal,
  showEmailProposalModal,
  sendEmail,
  changeContacts,
  setSubject,
  uploadFiles,
  files,
  removeFile
}) => {
  const [splitMode, setSplitMode] = useState(Object.keys(EMAIL_SPLIT_MODE)[1])
  const { name } = proposal
  return (
    <Modal keyboard={false} backdrop="static" isOpen={showEmailProposalModal} size="xl">
      <ModalHeader className={s.modalHeader}>Send Email</ModalHeader>
      <ModalBody>
        <div className={s.main}>
          <Container>
            <div className={s.emailType}>
              <span>How would you like emails to be sent?</span>
              <input
                type="radio"
                checked={splitMode === Object.keys(EMAIL_SPLIT_MODE)[0] || false}
                onChange={() => {
                  setSplitMode(Object.keys(EMAIL_SPLIT_MODE)[0])
                }}
              />{' '}
              {EMAIL_SPLIT_MODE[Object.keys(EMAIL_SPLIT_MODE)[0]]}
              <FaInfoCircle id="Type1" className={s.tooltip} />
              <UncontrolledTooltip placement="top" target="Type1">
                Works like a BCC. Use this option when sending email to people from different
                companies and you don&apos;t want a recipient to see everyone else on the list. Best
                option for mass email campaigns.
              </UncontrolledTooltip>
              <input
                type="radio"
                checked={splitMode === Object.keys(EMAIL_SPLIT_MODE)[1] || false}
                onChange={() => {
                  setSplitMode(Object.keys(EMAIL_SPLIT_MODE)[1])
                }}
              />{' '}
              {EMAIL_SPLIT_MODE[Object.keys(EMAIL_SPLIT_MODE)[1]]}
              <FaInfoCircle id="Type2" className={s.tooltip} />
              <UncontrolledTooltip placement="top" target="Type2">
                Use this option when you want to group contacts from the same company so they see
                which colleagues were sent this email. If you selected contacts from more than 1
                company, they will be grouped accordingly.
              </UncontrolledTooltip>
              <input
                type="radio"
                checked={splitMode === Object.keys(EMAIL_SPLIT_MODE)[2] || false}
                onChange={() => {
                  setSplitMode(Object.keys(EMAIL_SPLIT_MODE)[2])
                }}
              />{' '}
              {EMAIL_SPLIT_MODE[Object.keys(EMAIL_SPLIT_MODE)[2]]}
              <FaInfoCircle id="Type3" className={s.tooltip} />
              <UncontrolledTooltip placement="top" target="Type3">
                Use this option when you want each recipient to see everyone else on the email.
                Please note that this option is not appropriate for email campaigns or mass
                emailing.
              </UncontrolledTooltip>
            </div>
            <Row>
              <Col lg="6">
                <div className={s.headerItem}>
                  <div className={s.item}>
                    <label>To:</label>
                    <Select
                      onChange={value => changeContacts(value, 'toContacts')}
                      options={mainContacts}
                      value={toContacts.length ? toContacts : null}
                      isMulti
                      className={cn(s.itemSelect, s.toSelect)}
                    />
                  </div>
                  <div className={s.item}>
                    <label>CC:</label>
                    <Select
                      onChange={value => changeContacts(value, 'ccContacts')}
                      options={allCCContacts}
                      value={ccContacts}
                      isMulti
                      className={cn(s.itemSelect, s.ccSelect)}
                    />
                  </div>
                </div>
              </Col>
              <Col lg="6">
                <div className={s.headerItem}>
                  <div className={cn(s.item, s.leftSideItem)}>
                    <label>BCC:</label>
                    <CreatableSelect
                      isClearable
                      isMulti
                      onChange={value => changeContacts(value, 'bccContacts')}
                      options={allCCContacts}
                      className={cn(s.itemSelect, s.ccSelect)}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <div className={s.headerItem}>
                  <div className={s.item}>
                    <label className={s.subjectLabel}>Email Subject:</label>
                    <InputContainer
                      type="text"
                      text={subject}
                      placeholder="Email Subject"
                      cb={value => setSubject(value)}
                      style={{ display: 'inline-block', width: '81%', marginLeft: '2%' }}
                      classname={s.itemInput}
                    />
                  </div>
                </div>
                <div className={s.headerItem}>
                  <div className={s.item}>
                    <label className={s.attachmentLabel}>Attachments:</label>
                    <div
                      style={{ display: 'inline-block', width: '88%', marginLeft: '2%' }}
                      className={s.attachmentsContainer}
                    >
                      <button className={s.uploader}>Choose Files</button>
                      <input
                        type="file"
                        onChange={uploadFiles}
                        className={s.uploadInput}
                        multiple
                      />
                      <div className={s.attachment}>
                        <FaRegFilePdf />
                        {`${name}.pdf`}
                      </div>
                      {files.length > 0 && <EmailFiles removeFile={removeFile} files={files} />}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg="12">
                <TextEditor
                  template={emailBody}
                  actions={[
                    {
                      text: 'Send Email',
                      cb: (template, title, subject, destroyEditor) => {
                        sendEmail(template, destroyEditor, splitMode)
                      },
                      className: s.saveBtn,
                      enabled: toContacts.length
                    },
                    {
                      text: 'Cancel',
                      cb: (content, title, subject, destroyEditor) => {
                        destroyEditor?.()
                        toggleEmailProposalModal()
                      }
                    }
                  ]}
                />
              </Col>
            </Row>
          </Container>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default EmailProposalModal
